/**
 * Ryan O'Dowd
 * 2024-12-07
 * © Copyright 2024 Oakwood Software Consulting, Inc. All Rights Reserved.
 */
import React from 'react';
import Text from '@components/common/Text';
import {
  TouchableOpacity,
} from 'react-native';
import getStyles from './styles';
import hooks from '@hooks';

const Option = (props: OptionProps) => {
  const styles = hooks.useStyles(getStyles);

  return (
    <TouchableOpacity
      style={[
        styles.filterButton,
        props.selected && styles.filterButtonSelected,
      ]}
      onPress={props.onPress}
    >
      <Text
        style={[
          styles.filterLabel,
          props.selected && styles.filterLabelSelected,
        ]}
      >
        {`${props.text}`}
      </Text>
    </TouchableOpacity>
  );
};

class OptionProps {
  text: string | number; // @TODO: when can this be a number?
  onPress: () => void;
  selected: boolean;
};

export default Option;
